<template>
  <div class="divide-y divide-slate-200 rounded-b border">
    <AssignablePerson
      v-for="assignablePerson in assignablePeople"
      :key="assignablePerson.user.id"
      :assignable-person="assignablePerson"
      :with-availability="withAvailability"
      :all-availability-items="allAvailabilityItems"
      @fetch-events="$emit('fetch-events')"
    />
  </div>
</template>

<script>
import AssignablePerson from '@c/Dashboard/Content/Planning/components/AssignablePerson.vue'

export default {
  name: 'AssignablePeopleList',
  components: { AssignablePerson },
  props: {
    allAvailabilityItems: {
      type: Array,
      required: false,
      default: () => []
    },
    assignablePeople: {
      type: Array,
      default: () => []
    },
    withAvailability: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['fetch-events']
}
</script>
